<template>
<div class="px-1 pt-1">
  <div class="input-group pb-3">
    <button class="btn btn-outline-primary" @click="routeToCreateView()">
      <font-awesome-icon :icon="['fas', 'person-dolly']" />
      {{ $t('action.newEllipsis') }}
    </button>
  </div>

  <SupplierList @selected="goToSupplier" />
</div>
</template>

<script setup lang="ts">
import SupplierList from '@/components/masterdata/SupplierList.vue';
import { router } from "@/services";

const goToSupplier = async (supplierId: number) => {
  await router.push({ name: 'supplier', params: { supplierId: supplierId } });
}

const routeToCreateView = async () => {
  await router.push({ name: 'supplier-create' });
}
</script>
